module.exports = __webpack_public_path__ + "static/media/29FUNOV14.67dd5088.jpg";